"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _rebass = require("rebass");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Anchor = (0, _styledComponents.default)(_rebass.Link)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  font-family: ", ";\n  border: none;\n  background: none;\n  cursor: pointer;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"], ["\n  font-family: ", ";\n  border: none;\n  background: none;\n  cursor: pointer;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fonts.roboto;
});
Anchor.defaultProps = {
  as: 'a',
  color: 'black'
};
var _default = Anchor;
exports.default = _default;
var templateObject_1;